import { BookOpen } from "lucide-react";
import { Link } from "react-router-dom";

export function Logo({ light = false, size = "md" }) {
  const text = size === "lg" ? "text-2xl" : "text-xl";
  return (
    <Link to="/" className="flex items-center gap-2 group" data-testid="logo">
      <div className="w-9 h-9 rounded-xl bg-primary flex items-center justify-center shadow-md group-hover:rotate-6 transition-transform">
        <BookOpen className="w-5 h-5 text-white" strokeWidth={2.5} />
      </div>
      <span className={`font-heading font-extrabold ${text} ${light ? "text-white" : "text-slate-900"}`}>
        Slim<span className="text-accent">Avontuur</span>
      </span>
    </Link>
  );
}

export function Avatar({ emoji, size = "md", ring = true }) {
  const dims = { sm: "w-9 h-9 text-lg", md: "w-12 h-12 text-2xl", lg: "w-20 h-20 text-4xl" }[size];
  return (
    <div className={`${dims} rounded-full bg-secondary flex items-center justify-center ${ring ? "ring-4 ring-white shadow-sm" : ""}`}>
      <span>{emoji}</span>
    </div>
  );
}

export function ProgressBar({ value, className = "", color = "bg-accent" }) {
  return (
    <div className={`h-3 rounded-full bg-slate-100 overflow-hidden ${className}`}>
      <div className={`h-full ${color} rounded-full transition-all duration-700`} style={{ width: `${Math.max(0, Math.min(100, value))}%` }} />
    </div>
  );
}

export function NeonLogo({ size = "md" }) {
  const text = size === "lg" ? "text-2xl" : "text-lg";
  return (
    <Link to="/" className="flex items-center gap-2.5 group" data-testid="logo">
      <div className="w-9 h-9 rounded-xl flex items-center justify-center box-glow-cyan group-hover:rotate-6 transition-transform" style={{ background: "linear-gradient(135deg,#00FFD1,#6366F1)" }}>
        <BookOpen className="w-5 h-5 text-black" strokeWidth={2.5} />
      </div>
      <span className={`font-display font-extrabold ${text} text-white`}>Slim<span className="neon-gradient-text">Avontuur</span></span>
    </Link>
  );
}
